export const BANNER_LINK = {
  VIDEO_MESSAGE : '/video/message-maker' ,
  CHARACTER_SELFIE: '/album?type=character_selfie',
  GIFT: '/giftbox/point',
  NOTIFICATION: '/notification',
};